interface StatsCardProps {
  label: string;
  value: string;
}

export function StatsCard({ label, value }: StatsCardProps) {
  return (
    <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-3xl bg-primary/20 p-4">
      <p className="text-slate-700 dark:text-slate-300 text-sm font-medium leading-normal">
        {label}
      </p>
      <p className="text-slate-900 dark:text-white tracking-light text-2xl font-bold leading-tight">
        {value}
      </p>
    </div>
  );
}
